module.exports = __webpack_public_path__ + "img/10.6d20d1f9.jpg";